
import React, { useEffect, useState } from "react";
import { Navbar, Nav, Offcanvas, Button, Collapse, OverlayTrigger, Tooltip, Col, Container, Row } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../assets/css/sidebar.css"
import ClientesDados from "./ClientesDados";
import ClientesAgendamentos from "./ClientesAgendamentos";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import ClienteCadEdit from "../ClienteCadEdit";
import AnimaisClientes from "../../Animais/AnimaisClientes";
import { useLocation, useNavigate } from "react-router-dom";
import Template from "../../../layout/Template";
import { ClienteService } from "../../../services/api/Clientes/ClienteService";


export default function ClienteMenuLateral({ children, idCliente }) {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [showMobile, setShowMobile] = useState(false);
    const [openCadastros, setOpenCadastros] = useState(false);
    const [openConfig, setOpenConfig] = useState(false);
    const [cliente,setCliente]= useState(null)

    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

    const [contentMenu, setContentMenu] = useState('dados')

    const handleSelectOpcao = (e) => {
       navigate(e.target.value)
    }

  const location = useLocation();
    const currentPath = location.pathname;
    const navigate = useNavigate()

    const fetchCliente =  async ()=>{
        const data = await ClienteService.getById(idCliente);
        if(data.success){
            setCliente(data.data)
        }
    }

    useEffect(()=>{
fetchCliente()
    },[])

    const menuItems = [
        {
            icon: "",
            label: "Dados do cliente",
            link: "/admin/clientes/cadEdit/"+idCliente,
            content: "dados"
        },
        {
            icon: "",
            label: "Animais",
            link: "/admin/clientes/"+idCliente+"/animais",
            content: "animais"
        },
        {
            icon: "",
            label: "Agendamentos",
            link: "/admin/clientes/"+idCliente+"/agendamentos",
            content: "agendamentos"
        },
        /*  {
              icon: "📂",
              label: "Cadastros",
              submenu: [
                  { label: "Clientes", link: "#clientes" },
                  { label: "Produtos", link: "#produtos" },
                  { label: "Fornecedores", link: "#fornecedores" },
              ],
              open: openCadastros,
              toggle: () => setOpenCadastros(!openCadastros),
          },
          {
              icon: "⚙",
              label: "Configurações",
              submenu: [
                  { label: "Usuários", link: "#usuarios" },
                  { label: "Permissões", link: "#permissoes" },
              ],
              open: openConfig,
              toggle: () => setOpenConfig(!openConfig),
          },
          {
              icon: "📊",
              label: "Relatórios",
              link: "#relatorios",
          },*/
    ];

useEffect(() => {
        let path = currentPath.split('/')
        setContentMenu(path[2])
      //  setSubContentMenu(path[2])
        switch (path[2]) {
            case 'usuarios':
            case 'gruposUsuarios':
              
                break;
        }
        if (path[3] != undefined) {
          ///  setSubContentMenu(path[3])
        }
       console.log(path)

    }, [])


    const carregaConteudo = () => {
        return
    }

              

    return (
        <Template>        <div className="d-flex" id="container-interno">
            {/* Sidebar desktop */}
            <div id="sidebar"
                className="d-none d-lg-flex flex-column"
                style={{
                    width: sidebarOpen ? "220px" : "70px",
                    minHeight: "100vh",
                    transition: "width 0.3s ease",
                    overflowX: "hidden",
                }}
            >
                {/* Botão de toggle */}
                <div className="p-2 border-bottom border-secondary">
                    <h5 className="text-primary text-center">Cliente</h5>
                    <small>{cliente?.nome}</small>
                    {/*<Button variant="link" className="text-white" onClick={toggleSidebar}>
                        {sidebarOpen ? "⬅" : "➡"}
                    </Button>*/}
                </div>

                <Nav className="flex-column" >
                    {menuItems.map((item, idx) => (
                        <div key={idx}>
                            {item.submenu ? (
                                <>
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={!sidebarOpen ? <Tooltip>{item.label}</Tooltip> : <></>}
                                    >
                                        <Button
                                            variant="link"
                                            className=" text-start w-100"
                                            onClick={item.toggle}
                                        >
                                            {item.icon} {sidebarOpen && item.label}
                                        </Button>
                                    </OverlayTrigger>

                                    <Collapse in={item.open}>
                                        <div className="ps-4">
                                            {item.submenu.map((sub, sIdx) => (
                                                <Nav.Link key={sIdx} href={sub.link} className="text-white-50" onClick={() => setContentMenu(sub.content)}>
                                                    {sidebarOpen && sub.label}
                                                </Nav.Link>
                                            ))}
                                        </div>
                                    </Collapse>
                                </>
                            ) : (
                                <OverlayTrigger
                                    placement="right"
                                    overlay={!sidebarOpen ? <Tooltip>{item.label}</Tooltip> : <></>}
                                >
                                    <Nav.Link href={item.link} className="text-white" onClick={() => setContentMenu(item.content)}>
                                        {item.icon} {sidebarOpen && item.label}
                                    </Nav.Link>
                                </OverlayTrigger>
                            )}
                        </div>
                    ))}
                </Nav>
            </div>

            {/* Navbar Mobile 
            <Navbar bg="" variant="" expand={false} className="d-lg-none w-100">
                <Button variant="info" onClick={() => setShowMobile(true)}>
                    ☰ Menu
                </Button>
            </Navbar>*/}

            {/* Offcanvas Mobile */}
            <Offcanvas show={showMobile} onHide={() => setShowMobile(false)} id="menu-mobile">
                <Offcanvas.Header closeButton closeVariant="white">
                    <Offcanvas.Title>Menu</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Nav className="flex-column">
                        {menuItems.map((item, idx) => (
                            <div key={idx}>
                                {item.submenu ? (
                                    <>
                                        <Button
                                            variant="link"
                                            className="text-white text-start w-100"
                                            onClick={item.toggle}
                                        >
                                            {item.icon} {item.label}
                                        </Button>
                                        <Collapse in={item.open}>
                                            <div className="ps-4">
                                                {item.submenu.map((sub, sIdx) => (
                                                    <Nav.Link key={sIdx} href={sub.link} className="text-white-50" onClick={() => { setContentMenu(sub.content); setShowMobile(false) }}>
                                                        {sub.label}
                                                    </Nav.Link>
                                                ))}
                                            </div>
                                        </Collapse>
                                    </>
                                ) : (
                                    <Nav.Link href={item.link} className="text-white" onClick={() => { setContentMenu(item.content); setShowMobile(false) }}>
                                        {item.icon} {item.label}
                                    </Nav.Link>
                                )}
                            </div>
                        ))}
                    </Nav>
                </Offcanvas.Body>
            </Offcanvas>



            {/* Conteúdo principal */}
            <div className="flex-grow-1" style={{ padding: '0px 0px 10px' }}>
                <Container fluid id="cliente-header">
                    <Row>

                    </Row>
                    <Row>
                        <Col>
                            <span>Você está visualizando a ficha do(a) cliente </span>
                            <span className="text-default bold"><span className="mr-10">{cliente?.nome} {cliente?.sobrenome} </span>

                                { /*           <Button variant="primary" size="sm" href={'/clientes/cadEdit/' + cliente?.id}><FontAwesomeIcon icon={faPenToSquare} /> Editar</Button>
                         */}   </span>
                        </Col>
                    </Row>

                </Container>

                <div className="d-lg-none w-100 box-fundo mb-15">

                    <label className="mb-10">  Selecione a opção:</label>
                    <select className="form-control form-select" onChange={(e) => handleSelectOpcao(e)}>

                        {menuItems?.map((item) => (
                            <option value={item.link}>{item.label}</option>
                        ))}
                    </select>
                </div>

                <div id="divContent-sidebar">
                        {children}
                </div>

            </div>
        </div>
        </Template>

    );
}
